export default {
  common: {
    unexpected: '發生意外錯誤',
    tryAgain: '請稍後再試',
    refresh: '重新整理頁面'
  },
  network: {
    offline: '您似乎已離線',
    connectionLost: '連線已中斷',
    serverError: '伺服器錯誤',
    requestFailed: '請求失敗'
  },
  game: {
    loadFailed: '無法載入遊戲',
    unsupported: '您的瀏覽器可能不支援此遊戲',
    missingDependencies: '缺少執行遊戲所需的元件'
  },
  validation: {
    required: '此欄位為必填',
    email: '請輸入有效的電子郵件地址',
    minLength: '請輸入至少 {min} 個字元',
    maxLength: '不能超過 {max} 個字元'
  }
}; 